export const STAGES = {
  EMAIL: 'EMAIL',
  REALM: 'REALM'
}
